import { Fragment, useEffect } from 'react';
import { HelpGuide, helpGuideSections, isGuideActive } from '../data/helpGuides';

const renderGuideDescription = (guide: HelpGuide) => {
    return (
        <p>
            {guide.strongIntro && <><strong>{guide.strongIntro}</strong> </>}
            {guide.description}
            {guide.descriptionLink && <>
                {' '}
                <a className='help-file-link' href={guide.descriptionLink.href}>{guide.descriptionLink.text}</a>
                {guide.descriptionAfterLink}
            </>}
            {guide.emphasis && <>
                <br></br> <span className='help-file-em'>{guide.emphasis}</span>
            </>}
        </p>
    );
};

const Help = () => {
    useEffect(() => {
        document.title = 'countbubble Support';
    }, []);

    return (
        <section id="help-section">
            <div className="section">
                <div className="row justify-content-center">
                    <div className="column-medium-7">
                        <h1>countbubble Support</h1>
                        <h2>Need help or have a question?</h2>

                        <p>Check out our Guides and Tutorials to see if we've already answered your questions.</p>
                        <p>We've covered lots of key topics, and most of the "How To" guides include links to short videos.</p>

                        <p>If you can't find your answer, please contact us at <a className='email-link' href="mailto:contact@countbubble.com?subject=I have a question">contact@countbubble.com</a></p>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="column-medium-7">
                        <h2>Guides and Tutorials</h2>

                        {helpGuideSections.map(section => (
                            <Fragment key={section.title}>
                                <h3>{section.title}</h3>
                                {section.description && <p>{section.description}</p>}

                                {section.groups.map((group, groupIndex) => {
                                    const visibleGuides = group.guides.filter(guide => guide.showOnHelp !== false && isGuideActive(guide));

                                    if (visibleGuides.length === 0) {
                                        return null;
                                    }

                                    return (
                                    <Fragment key={group.title || groupIndex}>
                                        {group.title && <h4>{group.title}</h4>}
                                        <ul>
                                            {visibleGuides.map(guide => (
                                                <li key={guide.id}>
                                                    <a className='help-file-link' href={guide.href}>{guide.title} {guide.linkSuffix}</a>
                                                    {renderGuideDescription(guide)}
                                                </li>
                                            ))}
                                        </ul>
                                    </Fragment>
                                    );
                                })}
                            </Fragment>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    )
};

export default Help;
